var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('page',{attrs:{"articleSlug":_vm.articleSlug,"section":_vm.section},on:{"pageTitle":function($event){_vm.pageTitle = $event}}}),_c('div',{staticClass:"space"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }